import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

//import { theme } from '@ecp/common/src/style/theme/default';
import moTheme from '@ecp/common/src/style/theme/mo';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';

const BenefitChipRoot = styled(FlexBox)`
  padding: 0 4px;
  height: ${({ height }) => height};
  border-radius: 4px;
  font-size: 11px;
  color: white;
  background-color: ${({ item }) =>
    {
      if (item === '한정수량' || item === '대량구매') {
        return '#23A0B1';
      } else {
        return '#FF5624';
      }
    }
  };
`;

const GoodBenefitChip = ({ item, size = moTheme.font.size.$11, height = '18px' }) => (
  <BenefitChipRoot item={item} size={size} height={height}>
    {item}
  </BenefitChipRoot>
);

GoodBenefitChip.propTypes = {
  item: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
};

export default GoodBenefitChip;
